<div [ngClass]="{'selected': slotHasNoPlaylistNorPlayrule()} "
     [style.background]="slotHasNoPlaylistNorPlayrule() ? null : getGradientStyle()"
     class="edit-day-schedule-container-item">
  <div class="title">
    <div [style.color]="name === '' ? 'red' : ''" class="playlist-name">
      {{ name !== '' ? name : ('playlistpicker.title' | translate) + (name === '' ? ' ⚠️' : '') }}
    </div>
    <div class="right-column">
      <div *ngIf="timeSlot" class="timeslot">
        {{ timeSlot | hourstamp: "startTime" : "hh:mm" }} > {{ timeSlot | hourstamp: "endTime" : "hh:mm" }}
      </div>
      <div *ngIf="!timeSlot" class="timeslot">
        <label>--h-- > --h--</label>
      </div>
      <div class="action-row">
        <mwo-button (click)="handleEdit()" [active]="activeEdit" [icon]="'edit'"></mwo-button>
        <!--<mwo-button (click)="handleDelete()" [disable]="disableDelete" [icon]="'delete'"></mwo-button>-->
      </div>
    </div>
  </div>
</div>
